import axios from 'axios';

axios.defaults.withCredentials = true;
// axios.defaults.baseURL = 'https://hamis.alphaif.com';
axios.interceptors.response.use(  // 拦截器
  response => {
    const resultCode = response.data.resultCode;
    if (resultCode === '0') {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    const resultCode = error.response.data.resultCode;
    if (error.request.status === 404 && error.request.responseURL) {
      window.location.href = error.request.responseURL;
    }
    switch (resultCode) {
      case '1': // 通用错误
        break;
      case '1000': // 系统错误
        break;
      case '1001':  // 未登录
        break;
      case '1002': // 用户名或密码错误
        break;
      case '1003': // 无权限访问
        break;
      case '1004': // 参数错误
        break;
      case '1005':  // 无记录
        break;
      case '1006': // 重定向认证中心
        break;
      case '1007': // 单点登录认证失败
        break;
      case '1008': // 错误access_token
        break;
      case '1009': // 缺少access_token
        break;
      case '2000': // ClientId已存在
        break;
      case '2001': // 该用户名已注册
        break;
      case '2002': // 手机号码错误
        break;
      default:
        break;
    }
  }
);

class Ajax {
  static async Get(url, params = {}, loadingObj = null) {
    if (loadingObj) loadingObj.loading = true;
    const resp = await axios.get(url, params);
    if (loadingObj) loadingObj.loading = false;
    if (resp.data.resultCode === '0') {
      return resp.data.resultData;
    } else {
      throw new Error(resp.data.msg);
    }
  }
  
  static async Post(url, params = {}, loadingObj = null) {
    if (loadingObj) loadingObj.loading = true;
    const resp = await axios.post(url, params ? params : {});
    if (loadingObj) loadingObj.loading = false;
    if (resp.data.resultCode === '0') {
      return resp.data.resultData ? resp.data.resultData : true;
    } else {
      throw new Error(resp.data.msg);
    }
  }
}

export default Ajax;
